var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view',{attrs:{"trueOrfalse":_vm.trueOrfalse},on:{"callBack":_vm.callBack}})],1):_c('router-view',{attrs:{"trueOrfalse":_vm.trueOrfalse}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }